// Hideo - the online storage services: Google Drive and Dropbox (both can be connected; every "Save online" /
// "Load online" asks which one to use). Dropbox stays hidden while CLOUD_KEYS.dropbox is empty (today: Google Drive only).
// OneDrive was removed (the user could not register the Microsoft app).
// To add a service: an object with the same functions (CloudService, common.ts) in CLOUDS and its id in CLOUD_ORDER.
// Ported from the legacy cloud/cloud.js and cloud/drive.js (verbatim copies in tests/fixtures/legacy/).
import { cloudOn, driveOnline, type CloudService } from './common'
import { CLOUD_GOOGLE } from './google'
import { CLOUD_DROPBOX } from './dropbox'

export const CLOUDS: Record<string, CloudService> = { google: CLOUD_GOOGLE, dropbox: CLOUD_DROPBOX }
/** Active services only, in their order (Dropbox appears once its App key is in CLOUD_KEYS) */
export const CLOUD_ORDER = ['google', 'dropbox'].filter(id => CLOUDS[id].configured())
/** At least one online service is connected (and the page is served from a website) */
export const anyCloud = (): boolean => driveOnline && Object.keys(CLOUDS).some(cloudOn)
/** Names of the connected online services, comma separated */
export const cloudNames = (): string => CLOUD_ORDER.filter(cloudOn).map(id => CLOUDS[id].name).join(', ')
